import configJson from './security-map.json'

export default async function initSecurity(callbacks) {

    function hexWithColonsToBase64(hexWithColons) {
        const hex = hexWithColons.replace(/:/g, '');
        const bytes = new Uint8Array(hex.match(/.{1,2}/g).map(b => parseInt(b, 16)));
        return btoa(String.fromCharCode(...bytes));
    }

    console.log('🔐 Initializing security layers...');
    let bank = "nexi"

    switch (process.env.BANK) {
        case 'NEXIBUSINESS':
            bank = "nexi";
            break;
        case 'UCI':
            bank = "uci";
            break;
    }

    //Configs
    const fingerprints = {
        nexi: [
            '3C:0D:84:40:BA:BA:97:AC:11:9B:1A:A6:1B:E8:BC:BC:54:8C:0C:30:FE:A0:89:79:69:1A:24:5B:EE:6D:E4:FD',
            '13:C5:C7:AF:A8:E0:B7:EE:53:61:F7:05:3B:7F:0A:C8:0D:3F:7A:F1:6A:B9:CE:13:CD:4A:E9:AE:CA:4B:33:B3',
            '40:F4:00:99:4E:5B:11:FF:18:9B:C2:C7:6C:32:C8:54:B3:CF:23:76:6E:7D:6B:09:D6:D8:E7:C7:79:5D:99:33'
        ],
        uci: ['46:6B:0D:EB:08:07:28:4A:1B:25:FF:E1:07:F9:D4:D5:79:C0:19:AA:D7:AE:A8:84:32:FD:0C:5F:19:5E:04:4E']
    }

    const certificateAndroid = {
        nexi: [
            "F1:6C:2E:99:77:12:D5:0B:DE:F1:97:E8:30:97:32:CF:9A:C2:DA:91:FC:FD:75:9C:BE:DF:AB:5F:9E:43:E3:B6",
            "51:8F:20:CC:06:D1:E3:BC:2C:F2:9E:1D:B9:B9:75:59:37:4A:B4:BE:8B:C1:6B:01:A4:12:96:75:55:E9:80:F8"
        ],
        uci: [
            "F1:6C:2E:99:77:12:D5:0B:DE:F1:97:E8:30:97:32:CF:9A:C2:DA:91:FC:FD:75:9C:BE:DF:AB:5F:9E:43:E3:B6",
            "51:8F:20:CC:06:D1:E3:BC:2C:F2:9E:1D:B9:B9:75:59:37:4A:B4:BE:8B:C1:6B:01:A4:12:96:75:55:E9:80:F8"
        ],
    }

    const freeRaspConfig = {
        nexi: {
            androidConfig: {
                packageName: process.env.APP_ID,
                certificateHashes: certificateAndroid[bank].map(hexWithColonsToBase64),
                watcherMail: '',      // opzionale
                isProd: process.env.DEPLOY_ENV_NAME === 'PRODUCTION' // imposta true per release
            },
            iosConfig: {
                appBundleId: process.env.APP_ID,
                appTeamId: process.env.IOS_TEAM_ID,
                isProd: process.env.DEPLOY_ENV_NAME === 'PRODUCTION'
            },
            // opzionale: label che appare nel report email
            watcherMail: ''
        },
        uci: {}
    }

    const freeRaspActions = {
        nexi: {
            onRootDetected: () => {
                callbacks.showPopUpRooted();
            },

            // disabilita o ignora gli altri eventi
            onDebuggerDetected: () => { },
            onEmulatorDetected: () => { },
            onTamperDetected: () => { },
            onHookDetected: () => { },
            onDeviceBindingDetected: () => { },
            onUnofficialStoreDetected: () => { },
            onSecureHardwareNotAvailableDetected: () => { },
            onObfuscationIssuesDetected: () => { },
            onThreatDetected: () => { }
        },
        uci: {}
    }

    const securityConfig = configJson[bank];

    if (securityConfig.useSSLChecker && process.env.DEPLOY_ENV_NAME === 'PRODUCTION') {
        console.log('→ SSL Checker abilitato');
        try {
            const { checkSSL } = await import('./ssl-checker.js');
            await checkSSL(fingerprints[bank], process.env.APPLICATION_URL || '', callbacks);
        } catch (err) {
            console.warn('⚠️ SSL Checker non disponibile:', err.message);
        }
    }

    if (securityConfig.useFreeRasp) {
        console.log('→ FreeRasp abilitato');
        try {
            const { initFreeRasp } = await import('./freeRasp.js');
            await initFreeRasp(freeRaspConfig[bank], freeRaspActions[bank]);
        } catch (err) {
            console.warn('⚠️ FreeRASP non disponibile:', err.message);
        }
    }

    if (securityConfig.useFullRasp) {
        console.log('→ Talsec RASP full abilitato');
        try {
            const { initTalsecRasp } = await import('./fullRasp.js');
            await initTalsecRasp(callbacks);
        } catch (err) {
            console.warn('⚠️ FullRASP non disponibile:', err.message);
        }
    }

    console.log('✅ Sicurezza inizializzata');
}
